import {useTranslation} from "@Translation/hooks/useTranslation";
import {
    singleModalTranslationKey
} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";

interface HowLongContentProps {
    departure: string,
    destination: string,
    availableTransportation: string,
    durationMax: string,
}

function HowLongContent({departure, destination, availableTransportation, durationMax}: HowLongContentProps) {
    const title = useTranslation(
        `${singleModalTranslationKey}.how_long.title`,
        {departure, destination}
    )

    const content = useTranslation(
        `${singleModalTranslationKey}.how_long.description`,
        {departure, destination, availableTransportation, durationMax}
    )

    return (
        <TitleAndContent
            title={title}
            content={content}
        />
    )
}

export default HowLongContent